/**
 * Upload log schemas.
 *
 * Registry of all user-uploaded files (proof images, KYC docs, avatars, etc.)
 */
import { z } from 'zod';

/** POST /api/uploads — record a file upload. */
export const UploadCreateSchema = z.object({
  filename: z.string().min(1).max(255),
  original_name: z.string().min(1).max(255),
  mime_type: z.string().min(1).max(128),
  size_bytes: z.coerce.number().int().nonnegative().default(0),
  url: z.string().min(1).max(1024),
  category: z.enum([
    'avatar', 'kyc_front', 'kyc_back', 'kyc_selfie',
    'recharge_proof', 'other',
  ]).default('other'),
});
export type UploadCreateRequest = z.infer<typeof UploadCreateSchema>;

/** GET /api/admin/uploads — list uploads. */
export const UploadListQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(200).default(50),
  user_id: z.coerce.number().int().positive().optional(),
  category: z.string().max(32).optional(),
});
export type UploadListQuery = z.infer<typeof UploadListQuerySchema>;
